module.exports = __webpack_public_path__ + "img/女-鼻咽癌h.b5c99583.png";